module.exports = {"id":"219581","name":"Samuel Gigot","rating":"74","photo":"./data/images/photos/4/219581.png","club":{"name":"KAA La Gantoise","logo":"./data/images/clubs/KAALaGantoise.png"},"positions":["DC","DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SamuelGigot0.json
// module id = 3808
// module chunks = 0